module.exports = __webpack_public_path__ + "assets/img/slide-2.2b39a36a.png";